import { apiBaseUrl, jsonTypeHeaders } from './configuration';

export const destroy = (url, dispatch, additional_headers = {}) => request('delete', url, {}, dispatch, additional_headers);

export const get = (url, dispatch, additional_headers = {}) => request('get', url, null, dispatch, additional_headers);

export const post = (url, params, dispatch, additional_headers = {}) => request('post', url, params, dispatch, additional_headers);

export const put = (url, params, dispatch, additional_headers = {}) => request('put', url, params, dispatch, additional_headers);

export const patch = (url, params, dispatch, additional_headers = {}) => request('patch', url, params, dispatch, additional_headers);

// Le serveur ferme la porte : l'abonnement de l'entreprise n'est plus payé (402).
//
// Le parcours normal ne passe jamais par ici — l'écran a déjà lu `access.destination` et
// redirigé avant d'appeler quoi que ce soit. Ce renvoi est pour l'onglet resté ouvert
// pendant que l'essai expirait : sans lui, il verrait des écrans se vider un à un, sans une
// ligne d'explication.
//
// On lit une COPIE de la réponse : l'appelant lira l'originale, et un corps ne se lit
// qu'une fois.
const redirectToPayment = async (response) => {
  const body = await response.json().catch(() => ({}));
  const destination = (body.access && body.access.destination) === 'renewal' ? '/renewal' : '/subscribe';

  if (window.location.pathname !== destination) window.location.assign(destination);
};

// La session n'est plus valable (401). Le jeton a expiré, ou il a été expulsé par une
// connexion ailleurs : `devise_token_auth` ne garde que 10 sessions par compte et jette la
// plus ancienne.
//
// Sans ce renvoi, chaque écran traduisait le 401 dans SON vocabulaire : le bouton « copie
// sans prix » annonçait « Impossible de générer la copie sans prix » alors que le PDF se
// portait très bien — c'était la session qui était morte. Un appel refusé faute de session
// n'a qu'une seule suite utile, se reconnecter.
//
// Rechargement complet plutôt que `history.push` : le magasin garde un utilisateur qui
// n'existe plus côté serveur, et `/login` est une route publique — aucune boucle.
//
// Le paramètre est ce qui distingue ce renvoi d'une arrivée normale sur la connexion :
// l'écran s'en sert pour dire « Votre session a expiré » (`Login.js`, `avisDeSession`).
// Sans lui, on se retrouve devant un formulaire vide en plein travail, sans explication.
export const isSessionScoped = (url) => !url.startsWith('/auth') && !url.startsWith('/admin');

// Les deux familles exclues ci-dessus le sont pour la même raison — leur refus n'est ni
// une session perdue ni une facture à régler, et un rechargement complet n'y répond à rien :
//   - `/auth/…` : au démarrage `validate_token` répond 401 quand personne n'est connecté,
//     et `sign_in` répond 401 sur un mot de passe faux. L'écran de connexion dit déjà ce
//     qu'il faut, et l'y renvoyer en boucle l'empêcherait de le dire. Quant au 402 : ces
//     routes disent QUI on est, et c'est dans leur charge (`access.destination`) que les
//     barrières lisent où aller ; recharger la page sur leur réponse, c'est repartir de
//     zéro — la boucle `/login → /subscribe → /login` vue en mise en scène le 03-09 venait
//     d'un `validate_token` refusé en 402 pendant que la barrière le lisait comme « pas de
//     session ».
//   - `/admin…` : la console d'administration a SA session et SON écran de connexion
//     (`onUnauthorized`) ; l'envoyer sur `/login` la sortirait de chez elle.
// Test sur le seul chemin, sans le paramètre : plusieurs appels peuvent être refusés en même
// temps, et le premier qui a renvoyé doit clore la question.
const redirectToLogin = () => {
  if (window.location.pathname !== '/login') window.location.assign('/login?session_expired=true');
};

const request = async (method, url, params, dispatch, additionalHeaders = {}) => {
  let body = null;
  if (method !== 'get') {
    body = JSON.stringify(params);
  }

  const response = await fetch(apiBaseUrl + url,
    {
      body,
      method,
      headers: { ...jsonTypeHeaders, ...additionalHeaders },
    })
    .catch((error) => {
      console.log(error);
    });

  if (response && response.status === 402 && isSessionScoped(url)) redirectToPayment(response.clone());
  if (response && response.status === 401 && isSessionScoped(url)) redirectToLogin();

  return response;
};
